import { render, staticRenderFns } from "./aiChatDialog.vue?vue&type=template&id=b5aeb134"
import script from "./aiChatDialog.vue?vue&type=script&lang=js"
export * from "./aiChatDialog.vue?vue&type=script&lang=js"
import style0 from "./aiChatDialog.vue?vue&type=style&index=0&id=b5aeb134&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports